import React from 'react';
import PropTypes from 'prop-types';

import Title from '../Title';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const SecondaryTitle = ({
  children,
}) => (
  <Title className="font-medium text-lg">
    {children}
  </Title>
);

SecondaryTitle.propTypes = propTypes;

export default SecondaryTitle;
